// Stamp the no-JS gate on <html> as early as the bundle evaluates — before
// Stimulus registers or observes the DOM — so a failed boot degrades to the
// designed no-JS state instead of leaving controls in a broken half-state.
// Mirrors the prototype's init.js. Harmless for every tenant: the
// .js-only / .no-js-only rules ship only in the readout stylesheet.

export function stampJs(root = typeof document !== "undefined" ? document.documentElement : null) {
  if (root) root.classList.add("js")
  return root
}

// Side effect on import: this module is imported first by application.js, so the
// class lands before any Stimulus Application.start() runs later in the bundle.
stampJs()
